import React from 'react'
import FloorPlanContainer from '../Component/FloorPlanContainer'
import MainLayout from '../Component/MainLayout'
import SearchContextProvider from '../Context/SearchContextProvider'
import Splash from './Splash'

export default function Client() {
    return (
        <MainLayout needSearch>
            <Splash/>
            <FloorPlanContainer />
        </MainLayout>
        // </SearchContextProvider>
    )
}
